import type { Middleware } from '../tracker'

export function sampler(rate: number): Middleware {
  const r = Math.max(0, Math.min(1, rate))
  return (next) => ({
    track(event, payload, ctx) {
      if (Math.random() < r) {
        try { next.track(event, payload as any, ctx) } catch { /* noop */ }
      }
    }
  })
}

